module.exports = __webpack_public_path__ + "img/635D52_A9BCC0_B1AEA0_819598-256px.c2acb539.png";